import React from 'react';
import { Button } from 'components/button/index';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';

export const PolicyControlView = withTranslation()(
  class extends React.Component {
    formRef = React.createRef();

    componentDidUpdate() {
      this.formRef.current.reset();
    }

    render() {
      const { policy, children, showEditForm, toggleEdit, onEdit, onDelete, t } = this.props;

      return (
        <div className="policy-box">
          <div className="row policy-header">
            <div className="col">
              <h2 className={!showEditForm ? '' : 'd-none'}>{policy.organizationGroup}</h2>
              <div
                className={showEditForm ? 'input-group input-group-sm mb-3' : 'input-group input-group-sm mb-3 d-none'}
              >
                <form className="ct-one-line-form-with-controls" onSubmit={onEdit} ref={this.formRef}>
                  <input
                    type="text"
                    className="form-control "
                    placeholder={t('enter_group_organizational_unit')}
                    name="policy-name"
                    defaultValue={policy.organizationGroup}
                  />

                  <div className="input-group-append ct-one-line-form-controls">
                    <button
                      type="button"
                      className="btn link-button btn-link"
                      onClick={toggleEdit}
                      style={{ cursor: 'pointer' }}
                    >
                      {t('cancel')}
                    </button>
                    <Button type={'submit'}>{t('ok')}</Button>
                  </div>
                </form>
              </div>
            </div>
            {!showEditForm && (
              <div className="ct-edit-delete-icons">
                <FontAwesomeIcon icon={faPencil} onClick={toggleEdit} />
                <FontAwesomeIcon icon={faTrash} onClick={onDelete} />
              </div>
            )}
          </div>
          {children}
        </div>
      );
    }
  }
);
